import {
  Alert,
  alpha,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  Switch,
  Tab,
  Tabs,
  Typography,
  useTheme,
  Fade,
  Collapse,
  TextField,
  InputAdornment,
  IconButton,
  Checkbox,
  FormGroup,
  Drawer,
  useMediaQuery,
  Slider,
} from "@mui/material";

import useStyles from "./styles";
import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Check,
  CloseOutlined,
  BoltOutlined,
  MapOutlined,
  Animation,
  FilterList,
} from "@mui/icons-material";
import AlertModal from "../../alertModal";
import { useMapa } from "../../../contexts/mapaContext";
import CustomTreeView from "../../sideBar/customTreeView";
import { useOutletContext } from "react-router-dom";
import FiltroEscala from "../configModal/filtroEscala";
import { v4 as uuidv4 } from "uuid";

export default function ConfiguracaoMapModal({ open, setOpen = () => {} }) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [checkChanges, setCheckChanges] = useState(false);
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
  // página de alertas
  const [filterInterface, setFilterInterface] = useState(false);
  const [filterItems, setFilterItems] = useState(false);
  const [filterSeverity, setFilterSeverity] = useState(false);
  const [severityLevels, setSeverityLevels] = useState({
    5: true,
    4: false,
    3: false,
    2: false,
  });
  const [pageIndex, setPageIndex] = useState("1");
  const [escalaTrafego, setEscalaTrafego] = useState([]);
  const [escalaPotencia, setEscalaPotencia] = useState([]);
  const [filtroPotencia, setFiltroPotencia] = useState([]);
  const [filtroTrafego, setFiltroTrafego] = useState([]);
  const [animacaoLinha, setAnimacaoLinha] = useState(true);
  const [animacaoAlerta, setAnimacaoAlerta] = useState(true);

  //exlusivo ftth
  const [escalaFtth, setEscalaFtth] = useState([]);
  const [filtroFtth, setFiltroFtth] = useState([]);
  const [esconderOnu, setEsconderOnu] = useState(true);
  const [showOnusWithoutCto, setShowOnusWithoutCto] = useState(false);
  const [defaultSelectedItems, setDefaultSelectedItems] = useState(["1"]);

  const { config } = useOutletContext();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [larguraEnlace, setlarguraEnlace] = useState(7);

  const marksEnlace = [
    { value: 4, label: "Fina" },
    { value: 7, label: "Normal" },
    { value: 10, label: "Grossa" },
    { value: 13, label: "Muito Grossa" },
    { value: 16, label: "Extra Grossa" },
  ];

  function ensureEscalaId(escala) {
    return (escala || []).map((item) =>
      item.id ? item : { ...item, id: uuidv4() },
    );
  }

  const {
    configurationMap,
    setConfigurationMap,
    setElementSelected,
    setSnackbar,
    updateDataElementSocket,
    mapId,
    tipo,
    isPublic,
  } = useMapa();

  useEffect(() => {
    if (open) {
      setFilterInterface(
        configurationMap?.configuracoes?.alerts?.filterInterface?.enable ||
          false,
      );
      setFilterItems(
        configurationMap?.configuracoes?.alerts?.filterItens?.enable || false,
      );
      setFilterSeverity(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.enable ||
          false,
      );
      setSeverityLevels(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.severity || {
          5: true,
          4: false,
          3: false,
          2: false,
        },
      );
      setCheckChanges(false);

      setEscalaPotencia(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaPotencia?.escala),
      );
      setEscalaTrafego(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaTrafego?.escala),
      );
      setEscalaFtth(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaFTTH?.escala),
      );
      setFiltroPotencia(
        configurationMap?.configuracoes?.camadaPotencia?.filtros || [],
      );
      setFiltroTrafego(
        configurationMap?.configuracoes?.camadaTrafego?.filtros || [],
      );
      setFiltroFtth(configurationMap?.configuracoes?.camadaFTTH?.filtros || []);

      setAnimacaoLinha(
        configurationMap?.configuracoes?.animacao?.linha != null
          ? configurationMap?.configuracoes?.animacao?.linha
          : true,
      );
      setAnimacaoAlerta(
        configurationMap?.configuracoes?.animacao?.alertas != null
          ? configurationMap?.configuracoes?.animacao?.alertas
          : true,
      );
      setEsconderOnu(
        configurationMap?.configuracoes?.esconderOnu != null
          ? configurationMap?.configuracoes?.esconderOnu
          : true,
      );
      setShowOnusWithoutCto(
        configurationMap?.configuracoes?.showOnusWithoutCto != null
          ? configurationMap?.configuracoes?.showOnusWithoutCto
          : false,
      );
      setPageIndex({ title: "Animações", id: "1" });
      setlarguraEnlace(
        configurationMap?.configuracoes?.larguraEnlace != null
          ? configurationMap?.configuracoes?.larguraEnlace
          : 7,
      );
    }
  }, [open, configurationMap, config]);

  const handleClose = () => {
    setFilterInterface(false);
    setFilterItems(false);
    setFilterSeverity(false);
    setCheckChanges(false);
    setOpen(false);
    setSeverityLevels({ 5: false, 4: false, 3: false, 2: false });
    setDefaultSelectedItems(["1"]);
  };

  async function handleApiUpdateConfigMap() {
    if (isPublic) {
      setConfigurationMap((prev) => ({
        ...prev,
        configuracoes: {
          ...prev?.configuracoes,
          camadaPotencia: {
            filtros: filtroPotencia,
          },
          camadaTrafego: {
            filtros: filtroTrafego,
          },
          animacao: {
            linha: animacaoLinha,
            alertas: animacaoAlerta,
          },
        },
      }));
      handleClose();
      return;
    }

    const data =
      tipo !== "ftth"
        ? {
            id: configurationMap?.id,
            data: {
              ...configurationMap,
              mapId,
              configuracoes: {
                ...configurationMap?.configuracoes,
                tipo,
                alerts: {
                  filterInterface: { enable: filterInterface },
                  filterItens: { enable: filterItems },
                  filterSeverity: {
                    enable: filterSeverity,
                    severity: severityLevels,
                  },
                },
                animacao: {
                  linha: animacaoLinha,
                  alertas: animacaoAlerta,
                },
                camadaPotencia: {
                  filtros: filtroPotencia,
                },
                camadaTrafego: {
                  filtros: filtroTrafego,
                },
                larguraEnlace: larguraEnlace,
              },
            },
          }
        : {
            id: configurationMap?.id,
            data: {
              ...configurationMap,
              mapId,
              configuracoes: {
                ...configurationMap?.configuracoes,
                tipo,
                animacao: {
                  linha: animacaoLinha,
                  alertas: animacaoAlerta,
                },
                esconderOnu: esconderOnu,
                showOnusWithoutCto: showOnusWithoutCto,
                camadaFTTH: {
                  filtros: filtroFtth,
                },
              },
            },
          };

    try {
      const response = await api.put("/easyMaps/map/config/update", data);

      if (response.data.status === "Error") {
        setSnackbar({
          children:
            "Error: Não foi possível salvar as mudanças as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConfigurationMap(response.data);

          //setElementSelected(null);

          // setConfigLocal((prev) => ({
          //   ...prev,
          //   [tipo]: {
          //     ...prev[tipo],
          //     animacao: { linha: animacaoLinha, alertas: animacaoAlerta },
          //     filtroPotencia: filtroPotencia,
          //     filtroTrafego: filtroTrafego,
          //   },
          // }));
          handleClose();
          updateDataElementSocket?.();
          setSnackbar({
            children: "Configurações do mapa salvas com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      console.log("caiu no catch");
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  function handleSeverityChange(level) {
    const newLevels = { ...severityLevels, [level]: !severityLevels[level] };
    setSeverityLevels(newLevels);
    setCheckChanges(true);
  }

  const rightBarPages = useMemo(
    () => [
      {
        itemId: "1",
        label: "Animações",
        icon: <Animation />,
      },
      {
        itemId: "2",
        label: "Filtros",
        icon: <FilterList />,
      },
      ...(!isPublic && tipo != "ftth"
        ? [
            {
              itemId: "3",
              label: "Gerais",
              icon: <MapOutlined />,
            },
          ]
        : []),
    ],
    [isPublic],
  );

  const handleDrawerToggle = () => {
    setOpenDrawer((prevState) => !prevState);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1500 }}
      >
        <Card sx={isDownMd ? styles.containerMobile : styles.container}>
          <Stack
            sx={isDownMd ? styles.containerTabMobile : styles.containerTab}
          >
            {isDownMd ? (
              <>
                <IconButton sx={{ ml: 1 }} onClick={handleDrawerToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography sx={[styles.pageTitleMobile]}>
                  Ajustes do mapa
                </Typography>
                <Drawer
                  key={"Drawer-mobile"}
                  variant="temporary"
                  open={openDrawer}
                  onClose={() => setOpenDrawer(false)}
                  sx={styles.drawerMobile}
                >
                  <CustomTreeView
                    key="mobile-treeview"
                    fullWidth={true}
                    open={true}
                    defaultSelectedItems={defaultSelectedItems}
                    setOpen={() => {}}
                    //closeOnClickItem
                    titlePage={"Configurações"}
                    onItemSelect={(item) => {
                      setOpenDrawer(false);
                      setPageIndex({ title: item.label, id: item.itemId });
                    }}
                    onItemsIdSelected={(items) => {
                      setDefaultSelectedItems(items);
                    }}
                    items={rightBarPages}
                  />
                </Drawer>
              </>
            ) : (
              <>
                <Typography sx={[styles.pageTitle, { mb: -2 }]}>
                  Ajustes do mapa
                </Typography>

                <CustomTreeView
                  key="desktop-treeview"
                  fullWidth={true}
                  open={true}
                  defaultSelectedItems={defaultSelectedItems}
                  setOpen={() => {}}
                  //closeOnClickItem
                  titlePage={"Configurações"}
                  onItemSelect={(item) => {
                    setOpenDrawer(false);
                    setPageIndex({ title: item.label, id: item.itemId });
                  }}
                  items={rightBarPages}
                />
              </>
            )}
          </Stack>
          <Stack sx={styles.containerData}>
            <Typography sx={{ ...styles.pageTitle, ...styles.titlePage }}>
              {pageIndex.title}
            </Typography>

            <Stack
              gap={1.5}
              sx={{ height: "100%", overflow: "auto", pr: "5px" }}
            >
              {pageIndex.id == "1" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Switch
                      checked={animacaoAlerta}
                      onChange={() => {
                        setAnimacaoAlerta(!animacaoAlerta);
                        setCheckChanges(true);
                      }}
                      sx={styles.switch}
                    />
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        {" "}
                        Animação de Alertas
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Ativa animação visual para alertas nos itens do mapa
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Switch
                      checked={animacaoLinha}
                      onChange={() => {
                        setAnimacaoLinha(!animacaoLinha);
                        setCheckChanges(true);
                      }}
                      sx={styles.switch}
                    />
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        {" "}
                        Animação de Linhas
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Ativa animação visual para os enlaces dos itens do mapa
                      </Typography>
                    </Stack>
                  </Box>
                </>
              )}
              {pageIndex.id == "2" && (
                <>
                  {!isPublic && tipo != "ftth" && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={filterInterface}
                          onChange={() => {
                            setFilterInterface(!filterInterface);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtro de Alertas por Interface do host
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Mostra apenas alertas relacionados às interfaces
                            vinculadas aos hosts exibidos no mapa.
                          </Typography>
                        </Stack>
                        <Stack sx={{ p: 1 }}>
                          <Collapse
                            in={filterInterface}
                            timeout={300}
                            unmountOnExit
                          >
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                value={filterItems ? "true" : "false"}
                                onChange={(e) => {
                                  setFilterItems(e.target.value === "true");
                                  setCheckChanges(true);
                                }}
                              >
                                <FormControlLabel
                                  value={"false"}
                                  control={<Radio />}
                                  label={
                                    <Typography sx={styles.textSize}>
                                      Exibir alertas de todos os itens das
                                      interfaces selecionadas e itens
                                      explicitamente adicionados
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  value={"true"}
                                  control={<Radio />}
                                  label={
                                    <Typography sx={styles.textSize}>
                                      Exibir alertas apenas dos itens
                                      explicitamente adicionados
                                    </Typography>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </Collapse>
                        </Stack>
                      </Box>

                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={filterSeverity}
                          onChange={() => {
                            setFilterSeverity(!filterSeverity);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtro de Alertas por Severidade
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Escolha os níveis de severidade que deseja
                            visualizar nos alertas
                          </Typography>
                        </Stack>
                        <Stack sx={{ p: 1 }}>
                          <Collapse
                            in={filterSeverity}
                            timeout={300}
                            unmountOnExit
                          >
                            {/* <TextField
                          sx={styles.textField}
                          type="number"
                          //value={linkLight}
                          //onChange={(e) => {}}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    Nivel de Severidade
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        /> */}
                            <FormGroup
                              sx={{
                                display: "flex",
                                flexDirection: "row-reverse",
                                justifyContent: "flex-end",
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    defaultChecked
                                    //checked={severityLevels[5]}
                                    //onChange={() => handleSeverityChange(5)}
                                  />
                                }
                                label="Desatre"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[4]}
                                    onChange={() => handleSeverityChange(4)}
                                  />
                                }
                                label="Alto Impacto"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[3]}
                                    onChange={() => handleSeverityChange(3)}
                                  />
                                }
                                label="Moderado"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[2]}
                                    onChange={() => handleSeverityChange(2)}
                                  />
                                }
                                label="Alerta"
                              />
                            </FormGroup>
                          </Collapse>
                        </Stack>
                        <Collapse
                          in={filterSeverity}
                          timeout={300}
                          unmountOnExit
                        >
                          <Alert severity="info" sx={{ mt: 1 }}>
                            <Typography sx={styles.textFine}>
                              O filtro de severidade sobrepõe outros filtros. Se
                              estiver ativo, apenas os alertas com a severidade
                              selecionada serão exibidos.
                            </Typography>
                          </Alert>
                        </Collapse>
                      </Box>
                    </>
                  )}

                  {tipo != "ftth" && (
                    <>
                      <FiltroEscala
                        unit=""
                        type="Potência"
                        escala={escalaPotencia}
                        filtroData={filtroPotencia}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroPotencia}
                        theme={theme}
                        styles={styles}
                      />
                      <FiltroEscala
                        inverted={true}
                        unit=""
                        type="Tráfego"
                        escala={escalaTrafego}
                        filtroData={filtroTrafego}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroTrafego}
                        theme={theme}
                        styles={styles}
                      />
                    </>
                  )}

                  {tipo == "ftth" && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={esconderOnu}
                          onChange={() => {
                            setEsconderOnu(!esconderOnu);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Ocultar ONUs com CTO
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Quando ativo, as ONUs serão ocultadas no mapa. Para
                            exibir as ONUs será necessário selecionar uma CTO,
                            clicando nela no mapa.
                          </Typography>
                        </Stack>
                      </Box>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={!showOnusWithoutCto}
                          onChange={() => {
                            setShowOnusWithoutCto(!showOnusWithoutCto);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtrar ONUs sem CTO
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Quando ativo, apenas as ONUs que tem uma CTO serão
                            exibidas no mapa
                          </Typography>
                        </Stack>
                      </Box>
                      <FiltroEscala
                        unit="dBm"
                        type="Potência"
                        escala={escalaFtth}
                        filtroData={filtroFtth}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroFtth}
                        theme={theme}
                        styles={styles}
                      />
                    </>
                  )}
                </>
              )}
              {pageIndex.id == "3" && !isPublic && tipo != "ftth" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Espessura do Enlace
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Selecione o nível de espessura das linhas que
                        representam os enlaces no mapa. Opções mais altas tornam
                        as linhas mais grossas, facilitando a visualização em
                        mapas com muitos enlaces. No entanto, espessuras maiores
                        podem deixar o mapa visualmente mais carregado.
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      mt={2}
                      sx={{ width: "98%", p: "0px 19px" }}
                    >
                      <Slider
                        aria-label="Restricted values"
                        value={larguraEnlace}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setlarguraEnlace(e.target.value);
                        }}
                        min={4}
                        max={16}
                        step={null}
                        marks={marksEnlace}
                        valueLabelDisplay="off"
                        size="small"
                      />
                    </Stack>
                  </Box>
                </>
              )}
            </Stack>
            <Stack
              direction={"row"}
              gap={1}
              justifyContent={"flex-end"}
              sx={{ height: "50px", mt: 2, mb: 1 }}
            >
              <Button
                onClick={() => {
                  if (!checkChanges) {
                    handleClose();
                    return;
                  }
                  setOpenAlertModal({
                    open: true,
                    callback: handleClose,
                    severity: "error",
                    severity: "warning",
                    text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                  });
                }}
                sx={styles.buttomEnd}
                startIcon={<CloseOutlined />}
                variant="text"
                color="primary"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleApiUpdateConfigMap}
                sx={styles.buttomEnd}
                variant="contained"
                color="primary"
                startIcon={<Check />}
                disabled={!checkChanges}
                size="small"
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>

      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        buttonText={openAlertModal?.buttonText}
        buttonCancelText={openAlertModal?.buttonCancelText}
        confirmar={false}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          if (openAlertModal.callback) {
            openAlertModal.callback(...(openAlertModal?.params || []));
            return;
          }
        }}
        severity={openAlertModal?.severity}
        singleButton={false}
        textContent={openAlertModal?.text}
      />
    </>
  );
}
